import React,{useContext,useEffect, useState, useRef} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import UtilContext from '../../../components/UtilContext';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { ColorPicker } from 'primereact/colorpicker';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import { LocaleContext } from '../../../components/LocaleContext';

export default function ServiceStateAdd({service_state,type="add"}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,getSlovakColorName}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);


    const [formServiceState,setFormServiceState] = useState(service_state);
    const [formType, setFormType] = useState(type);

    const [scrollIcons,setScrollIcons] = useState(true);

    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);

    useEffect(() => {
        // Update the document title using the browser API
        console.log(service_state);
        if (formType === "edit") {
            setScrollIcons(false);
        }
    },[formType]);

    /* validate form */
    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const phasesOptions = [
        { name: t('ServiceState.Phase.Created'), code: 'created' },
        { name: t('ServiceState.Phase.Approval'), code: 'approval' },
        { name: t('ServiceState.Phase.SystemApproval'), code: 'system_approval' },
        { name: t('ServiceState.Phase.Execution'), code: 'execution' },
        { name: t('ServiceState.Phase.SystemExecution'), code: 'system_execution' },
        { name: t('ServiceState.Phase.Inspection'), code: 'inspection' },
        { name: t('ServiceState.Phase.SystemInspection'), code: 'system_inspection' },
        { name: t('ServiceState.Phase.Closing'), code: 'closing' },
        // ďalšie podľa potreby
    ];

    const transitionTypeOptions = [
        { name: t('ServiceState.TransitionType.NonFinal'), code: 'non_final' },
        { name: t('ServiceState.TransitionType.LevelFinal'), code: 'level_final' },
        { name: t('ServiceState.TransitionType.SectionFinal'), code: 'section_final' },
        { name: t('ServiceState.TransitionType.FinalManually'), code: 'final_manually' },
        { name: t('ServiceState.TransitionType.FinalAuto'), code: 'final_auto' },
        { name: t('ServiceState.TransitionType.Reopen'), code: 'reopen' },
    ];

    const applicableTypes = [
        {name: t('ServiceTask.Type.Info'),value:'Info'},
        {name: t('ServiceTask.Type.Task'),value:'Task'},
        {name: t('ServiceTask.Type.TechChange'),value:'TechChange'},
        {name: t('ServiceTask.Type.Error'),value:'Error'},
        {name: t('ServiceTask.Type.Permission'),value:'Permission'},
        {name: t('ServiceTask.Type.Need'),value:'Need'},
        {name: t('ServiceTask.Type.Borrow'),value:'Borrow'},
        {name: t('ServiceTask.Type.Emergency'),value:'Emergency'},
    ];
    /* form for adding error record */
    const formik = useFormik({
        initialValues: formServiceState==null?{
            name: '',applicable_types:[],color:'9ca3af',phase:'',transition_type:'',is_deletable:true
        }:{
            id:formServiceState?.id,name:formServiceState?.name,color:formServiceState?.color,
            applicable_types:formServiceState?.applicable_types ? formServiceState?.applicable_types : [],is_deletable:formServiceState?.is_deletable ? true : false,
            phase: phasesOptions.filter(phase => phase.code === formServiceState?.phase)[0],transition_type: transitionTypeOptions.filter(transition_type => transition_type.code === formServiceState?.transition_type)[0]
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if (value !== "phase" && value !== "transition_type") formData.append(value, values[value] != null ? values[value] : "");
                else formData.append(value, values[value] != null ? values[value]?.code : "");
            }
            if (formType === "add") {
                postRequest('/api/service_states', formData,true)
                .then((response) => {
                    console.log(response);
                    getRequest("/api/service_states").then((response) => {
                        dispatch({type:'load_service_states',newServiceStates:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setFormType("edit");
                        toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTask.RecordSaved') });
                    });
                }).catch((reason) => {
                    alert(t('ServiceTask.ActionFailed'));
                })
            }
            else{
                postRequest(`/api/service_states/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/service_states").then((response) => {
                        dispatch({type:'load_service_states',newServiceStates:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        formik.setValues(values);
                        toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTask.RecordUpdated') });
                    });
                }).catch((reason) => {
                    alert(t('ServiceTask.ActionFailed'));
                })
            }
        },
    });

      function copyDepartment(){
        dispatch({type:'create_new_tab',name: t('ServiceStateAdd.NewState'), translationKey: 'ServiceStateAdd.NewState', legacyLabel: t('ServiceStateAdd.NewState'),page:'ServiceStateAdd',props:{service_state: formik.values,type:'add'},mask:'intr007'})
      }
      function addNewDepartment(){
        dispatch({type:'create_new_tab',name: t('ServiceStateAdd.NewState'), translationKey: 'ServiceStateAdd.NewState', legacyLabel: t('ServiceStateAdd.NewState'),page:'ServiceStateAdd',props:{service_state: null,type:'add'},mask:'intr007'})
      }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createArrayNavigateHandlers(state.service_states, formik.values?.id, setFormServiceState);


return(
<>
<div>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => addNewDepartment()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => copyDepartment()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('ServiceStateAdd.Title'),"ServiceStateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("ServiceStateAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
<div className="relative flex flex-col justify-left overflow-x min-h-[calc(100vh-177px)]">
    <div className=" mb-2 ">
    <form onSubmit={formik.handleSubmit}>
        <div className="w-auto p-6 m-4 bg-gray-100">
            <h1 className="text-3xl font-semibold text-left text-zinc-900">
            {t('ServiceStateAdd.Title')}
            </h1>
            {formType === "edit" && (
            <label className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.SerialNumber')}: {formik.values.id}
            </label>
            )}

            <div className="mb-2">
            <label htmlFor="name" className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.StateName')}
            </label>
            <input
                id="name"
                name="name"
                type="text"
                disabled={!formik.values?.is_deletable}
                onChange={formik.handleChange}
                value={formik.values.name}
                className="block w-fit px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40 disabled:opacity-25"
            />
            </div>

            <div className="mb-2">
            <label htmlFor="applicable_types" className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.ShowIn')}
            </label>
            <MultiSelect
                id="applicable_types"
                disabled={!formik.values?.is_deletable}
                required
                value={formik.values.applicable_types || []}
                onChange={(e) => formik.setFieldValue("applicable_types", e.value)}
                options={applicableTypes}
                optionLabel="name"
                filter
                placeholder={t('ServiceStateAdd.SelectTypes')}
                className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40 disabled:opacity-25"
            />
            </div>

            <div className="mb-2">
            <label htmlFor="phase" className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.Phase')}
            </label>
            <Dropdown
                id="phase"
                disabled={!formik.values?.is_deletable}
                required
                value={formik.values.phase}
                onChange={(e) => formik.setFieldValue("phase", e.value)}
                options={phasesOptions}
                optionLabel="name"
                placeholder={t('ServiceStateAdd.SelectPhase')}
                className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40 disabled:opacity-25"
            />
            </div>

            <div className="mb-2">
            <label htmlFor="transition_type" className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.TransitionType')}
            </label>
            <Dropdown
                id="transition_type"
                disabled={!formik.values?.is_deletable}
                required
                value={formik.values.transition_type}
                onChange={(e) => formik.setFieldValue("transition_type", e.value)}
                options={transitionTypeOptions}
                optionLabel="name"
                placeholder={t('ServiceStateAdd.SelectTransitionType')}
                className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40 disabled:opacity-25"
            />
            </div>

            <div className="mb-2">
            <label htmlFor="color" className="block text-md font-semibold text-gray-800">
                {t('ServiceStateAdd.StateColor')}
            </label>
            <div className="mt-1 text-sm text-gray-800 flex items-center gap-2">
                <ColorPicker
                id="color"
                value={formik.values?.color || ''}
                onChange={(e) => formik.setFieldValue("color", e.value)}
                className="mr-2"
                />
                {t('ServiceStateAdd.SelectedColor')}: <span className="font-semibold">{'#' + formik.values?.color}</span> -{' '}
                <span>{getSlovakColorName('#' + formik.values?.color)}</span>
            </div>
            </div>
        </div>

        <button type="submit" ref={submitRef} className="hidden"></button>
    </form>
    </div>
    </div>
    </div>
    </>
    );
}